import { quickBooksApi } from './index';
import type { QuickBooksLtlFreightSourceType } from './index';

// FIX-ADMIN-RUSS-PDF (owner 2026-10-14): the Russ invoice PDF matched to one
// stock order / transfer, for "View Russ invoice" on the row menu
// (qb-worker GET /ltl/russ-invoice-link, lane flag qb.ltl.read). Company
// Owner, Accounting and, read-only, Administrative; the worker answers only
// the link (null when the record has no matched PDF).

export interface QuickBooksLtlRussInvoiceLink {
  qboTouched: false;
  receiptUrl: string | null;
}

export interface QuickBooksLtlRussInvoiceLinkArgs {
  sourceId: number;
  sourceType: QuickBooksLtlFreightSourceType;
}

export const ltlRussInvoiceLinkApi = quickBooksApi.injectEndpoints({
  endpoints: (build) => ({
    ltlRussInvoiceLink: build.query<
      QuickBooksLtlRussInvoiceLink,
      QuickBooksLtlRussInvoiceLinkArgs
    >({
      providesTags: ['QuickBooksControlCenter'],
      query: ({ sourceId, sourceType }) => ({
        method: 'get',
        headers: { 'allow-not-found': 'true' },
        url: `quickbooks/ltl/russ-invoice-link?sourceType=${encodeURIComponent(
          sourceType
        )}&sourceId=${encodeURIComponent(String(sourceId))}`,
      }),
    }),
  }),
});

export const { useLtlRussInvoiceLinkQuery } = ltlRussInvoiceLinkApi;
